<template>
  <div>
    <v-btn
      class="ma-2 no-display"
      tile
      outlined
      color="warning"
      @click="print()"
    >
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <div style="color: #233491; margin-top: 240px; font-size: 21px">
      <div class="row">
        <div class="col-4 text-left pb-0" style="">
          Certificate No. {{ lc_data.certificate_no }}
        </div>
        <div class="col-6 text-right pb-0" style="">
          G.R. No. {{ lc_data.gr_number }}
        </div>
      </div>
      <center>
        <table class="jr-table" style="width: 100%; font-size: 21px !important">
          <tr>
            <td>APAAR ID</td>
            <td>{{ lc_data.apaar_id }}</td>
          </tr>
          <tr>
            <td>PEN ID</td>
            <td>{{ lc_data.pen_no }}</td>
          </tr>
          <tr>
            <td>Unique (Aadhaar No.)</td>
            <td colspan="2" nowrap>{{ lc_data.aadhar_no }}</td>
          </tr>
          <tr>
            <td>1) Name of the Student in Full</td>
            <td colspan="2" nowrap>{{ lc_data.fullname }}</td>
          </tr>
          <tr>
            <td>2) Mother's Name</td>
            <td colspan="2" nowrap>{{ lc_data.mother_first_name }}</td>
          </tr>
          <tr>
            <td>3) Nationality</td>
            <td>{{ lc_data.nationality }}</td>
            <td>4) Mother Tongue - {{ lc_data.mothertoungue }}</td>
          </tr>
          <tr>
            <td>5) Religion, Caste & Sub-Caste</td>
            <td colspan="2" nowrap>
              {{ lc_data.religion }}-{{ lc_data.caste }}-{{ lc_data.subcaste }}
            </td>
          </tr>
          <tr>
            <td style="line-height: 100%">
              6) Place of Birth <br />
              <span style="font-size: small; margin-left: 15px"
                >(Village/City, Taluka, Zilla, State, Country)</span
              >
            </td>
            <td colspan="2" nowrap>{{ lc_data.birth_place }}</td>
          </tr>
          <tr>
            <td style="line-height: 100%">
              7) Date of Birth <br />
              <span style="font-size: small; margin-left: 15px"
                >(According to Christian era)</span
              >
            </td>
            <td colspan="2" nowrap>{{ lc_data.dob_fig }}</td>
          </tr>
          <tr>
            <td style="line-height: 100%">
              8) Date of Birth <br />
              <span style="font-size: small; margin-left: 15px"
                >(in words)</span
              >
            </td>
            <td colspan="3">{{ lc_data.dob_words }}</td>
          </tr>
          <tr>
            <td>9) Last School Attended Std.</td>
            <td colspan="3">{{ lc_data.last_school }}</td>
          </tr>
          <tr>
            <td>10) Date of Admission & Std.</td>
            <td>{{ lc_data.doa }}</td>
            <td>Std. - {{ lc_data.admittedstandard }}</td>
          </tr>
          <tr>
            <td>11) Progress</td>
            <td>{{ lc_data.progress }}</td>
            <td>12) Conduct : {{ lc_data.conduct }}</td>
          </tr>
          <tr>
            <td>13) Date of leaving the college</td>
            <td colspan="2" nowrap>{{ lc_data.last_date_of_school }}</td>
          </tr>
          <tr>
            <td>
              14) Standard in which Studying & Since when <br />
              <span style="font-size: small; margin-left: 15px"
                >(in words & figures)</span
              >
            </td>
            <td colspan="2" nowrap>
              {{ lc_data.standard }} Since {{ lc_data.standard_since_when }}
            </td>
          </tr>
          <tr>
            <td>15) Reason for Leaving the college</td>
            <td colspan="2" nowrap>{{ lc_data.reason }}</td>
          </tr>
          <tr>
            <td>16) Remarks</td>
            <td colspan="2" nowrap>{{ lc_data.remark }}</td>
          </tr>
        </table>
      </center>
      <div
        class="print-font"
        style="color: rgb(235, 61, 61); padding: 17px 0px 5px 17px"
      >
        Certified that the above information is in accordance with the
        Institute's General Register No. {{ lc_data.gr_number }}
      </div>
      <span class="print-font" style="padding-left: 17px"
        >Certificate Issuing Date : {{ lc_data.date_of_issue }}</span
      >
    </div>
    <br />
    <br />
    <br />
    <br />
    <div
      class="d-flex justify-space-between col-12 jr-last-row"
      style="position: absolute; bottom: 20px; color: rgb(235, 61, 61)"
    >
      <div class="text-center col-4">
        <center><b>CLASS TEACHER</b></center>
      </div>
      <div class="text-center col-4">
        <center><b> CLERK </b></center>
      </div>
      <div class="text-center col-4">
        <center><b>PRINCIPAL </b></center>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
      org_id: null,
    };
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
  },
};
</script>
<style scoped>
.text-color {
  color: #233491;
  padding: 20px;
}
.jr-table {
  border-collapse: collapse;
}
.jr-table td:nth-child(2) {
  border-right: none;
}
.jr-table td:first-child {
  width: 31%;
  border-left: none !important;
}
.jr-table,
.jr-table td,
.jr-table tr {
  border: 1px solid rgb(235, 61, 61);
  text-align: left;
  font-size: 17px;
  padding: 8px;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(235, 61, 61);
}
/* lc data css end */

/* print lc css */
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  .text-color {
    padding: 20px !important;
    margin-left: -15px;
  }
  .jr-table,
  .jr-table td {
    height: 40px !important;
    font-size: 21px !important;
  }
  .jr-table {
    width: 100% !important;
    height: 90vh;
  }

  .jr-last-row {
    font-size: 20px !important;
  }
  @page {
    /* size: A4; */
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */

.column {
  float: left;
}
</style>